import React from "react";

export const LogoSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="145"
    height="17"
    viewBox="0 0 145 17"
    fill="none"
  >
    <path
      d="M13.0364 3.87753L9.75016 4.97698C9.30837 3.6724 8.37183 3.01944 6.94189 3.01944C5.41474 3.01944 4.65184 3.51485 4.65184 4.50569C4.65184 4.90055 4.79463 5.23507 5.08022 5.50859C5.3658 5.78278 6.01139 6.02011 7.0163 6.2219C8.69697 6.56111 9.92781 6.90367 10.7081 7.25026C11.4885 7.59618 12.1461 8.15396 12.6811 8.92357C13.2161 9.69251 13.4836 10.5519 13.4836 11.5026C13.4836 12.9922 12.9097 14.2807 11.7633 15.368C10.6163 16.4554 8.91686 16.9984 6.66301 16.9984C4.97296 16.9984 3.5343 16.6136 2.34771 15.8447C1.16045 15.0757 0.3781 13.9341 0 12.4196L3.57653 11.6098C3.97877 13.1484 5.09564 13.9173 6.92848 13.9173C7.81273 13.9173 8.47172 13.7463 8.90614 13.4038C9.33988 13.0612 9.55709 12.6529 9.55709 12.1776C9.55709 11.7023 9.35999 11.3195 8.9658 11.0541C8.57161 10.7886 7.81139 10.5385 6.6858 10.3046C4.58614 9.86948 3.0905 9.27486 2.19754 8.52201C1.30458 7.76916 0.8581 6.6677 0.8581 5.21832C0.8581 3.76893 1.39106 2.51665 2.45698 1.50972C3.5229 0.503464 4.9696 0 6.79642 0C10.031 0 12.1113 1.29251 13.0364 3.87821V3.87753Z"
      fill="#00B7F0"
    />
    <path
      d="M23.3168 16.7455L19.2482 3.29881V16.7455H16.0103V0.253906H22.0263L24.9211 10.1247L27.966 0.253906H34.0002V16.7455H30.1099V3.29881L25.9615 16.7455H23.3175H23.3168Z"
      fill="#00B7F0"
    />
    <path
      d="M49.068 3.39468H41.215V6.77748H47.3887V9.88272H41.215V13.4834H49.068V16.7455H37.2886V0.253906H49.068V3.39535V3.39468Z"
      fill="#00B7F0"
    />
    <path
      d="M64.0712 0.253906V16.7455H60.7749L54.3211 5.60631C54.3291 5.88854 54.3372 6.07356 54.3452 6.16205C54.3774 6.44428 54.3935 6.68161 54.3935 6.87468V16.7455H51.3848V0.253906H55.5486L61.1591 9.97993C61.1108 9.49658 61.0867 9.13054 61.0867 8.88048V0.253906H64.0706H64.0712Z"
      fill="#00B7F0"
    />
    <path
      d="M80.3825 0.253906V10.5236C80.3825 12.1828 80.1935 13.417 79.8147 14.2268C79.4359 15.0367 78.7374 15.701 77.7184 16.2206C76.6994 16.7401 75.3968 16.9996 73.81 16.9996C72.2232 16.9996 70.9609 16.7656 70.0223 16.299C69.0838 15.8318 68.3812 15.1674 67.9139 14.3053C67.4467 13.4438 67.2134 12.1828 67.2134 10.5236V0.253906H71.406V10.5236C71.406 11.4099 71.4804 12.0622 71.6292 12.4811C71.7781 12.9001 72.0764 13.2327 72.5235 13.478C72.9707 13.7241 73.5204 13.8467 74.1727 13.8467C74.8974 13.8467 75.4873 13.7261 75.9425 13.484C76.3977 13.2427 76.6994 12.9223 76.8489 12.5234C76.9977 12.1245 77.0721 11.4581 77.0721 10.5236V0.253906H80.3825Z"
      fill="#00B7F0"
    />
    <path
      d="M83.4536 0.253906H91.1376C92.5146 0.253906 93.5497 0.42284 94.2429 0.760717C94.9354 1.09859 95.5072 1.58194 95.9584 2.20943C96.4096 2.83759 96.6348 3.60184 96.6348 4.50351C96.6348 6.33033 95.644 7.54976 93.663 8.16116C94.8067 8.41926 95.6641 8.93076 96.2366 9.69702C96.8085 10.4626 97.0947 11.2972 97.0947 12.1996C97.0947 13.4331 96.6275 14.499 95.6929 15.3973C94.7584 16.2963 93.2406 16.7455 91.1383 16.7455H83.4543V0.253906H83.4536ZM87.3077 3.16541V6.77815H90.2313C91.3025 6.77815 91.977 6.56696 92.2552 6.14395C92.5334 5.72093 92.6722 5.31669 92.6722 4.92988C92.6722 4.51088 92.5575 4.15089 92.3276 3.84854C92.0983 3.54619 91.8462 3.35714 91.5727 3.28072C91.2985 3.2043 90.7589 3.16608 89.9537 3.16608H87.3077V3.16541ZM87.3077 9.71378V13.6885H90.2735C91.2858 13.6885 92.0018 13.5115 92.4194 13.1569C92.8371 12.8023 93.0462 12.3075 93.0462 11.6707C93.0462 11.139 92.8451 10.6798 92.4436 10.2937C92.0413 9.90686 91.3743 9.71378 90.4424 9.71378H87.3077Z"
      fill="#00B7F0"
    />
    <path
      d="M105.763 16.9984C103.542 16.9984 101.823 16.1651 100.608 14.4979C99.3925 12.8306 98.7852 10.8127 98.7852 8.4449C98.7852 6.07709 99.4006 4.02704 100.632 2.41609C101.864 0.805141 103.618 0 105.895 0C108.173 0 109.933 0.860109 111.104 2.57966C112.275 4.29921 112.861 6.26681 112.861 8.48178C112.861 10.8737 112.257 12.8916 111.05 14.5347C109.843 16.1779 108.08 16.9991 105.763 16.9991V16.9984ZM105.871 3.15285C103.846 3.15285 102.833 4.93273 102.833 8.49317C102.833 12.0536 103.846 13.8456 105.871 13.8456C107.896 13.8456 108.814 12.0657 108.814 8.50525C108.814 4.94481 107.833 3.15285 105.871 3.15285Z"
      fill="#00B7F0"
    />
    <path
      d="M121.567 16.9984C119.346 16.9984 117.628 16.1651 116.413 14.4979C115.197 12.8306 114.59 10.8127 114.59 8.4449C114.59 6.07709 115.205 4.02704 116.437 2.41609C117.668 0.805141 119.423 0 121.7 0C123.977 0 125.738 0.860109 126.909 2.57966C128.079 4.29921 128.665 6.26681 128.665 8.48178C128.665 10.8737 128.061 12.8916 126.855 14.5347C125.647 16.1779 123.885 16.9991 121.567 16.9991V16.9984ZM121.676 3.15285C119.651 3.15285 118.638 4.93273 118.638 8.49317C118.638 12.0536 119.651 13.8456 121.676 13.8456C123.701 13.8456 124.618 12.0657 124.618 8.50525C124.618 4.94481 123.637 3.15285 121.676 3.15285Z"
      fill="#00B7F0"
    />
    <path
      d="M134.987 0.253906V8.00228L140.157 0.253906H143.855L139.894 6.14195L144.845 16.7455H140.591L137.3 9.58372L134.987 12.9638V16.7455H131.193V0.253906H134.987Z"
      fill="#00B7F0"
    />
  </svg>
);

export const ReplySVG = () => (
  <svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor">
    <path
      d="M537.016,909.264c-7.034,0-14.006-2.372-19.671-6.97L18.508,496.986C11.232,491.055,7,482.161,7,472.781
			c0-9.374,4.232-18.267,11.508-24.204L517.345,43.272c9.318-7.551,22.258-9.104,33.064-3.959
			c10.871,5.175,17.785,16.135,17.785,28.162v219.277c243.388,16.107,436.483,219.246,436.483,466.625v62.353
			c0,12.18-7.097,23.235-18.147,28.314c-11.054,5.119-24.054,3.292-33.311-4.626l-52.55-45.027
			c-93.318-79.986-210.359-126.841-332.476-133.66v217.36c0,12.022-6.914,22.986-17.785,28.158
			C546.146,908.262,541.58,909.268,537.016,909.264L537.016,909.264z M125.715,472.781L506.65,782.309V614.776
			c0-15.697,12.702-28.401,28.399-28.401c134.946,0,265.707,48.367,368.18,136.193l0.972,0.834
			c-2.664-201.286-167.231-364.213-369.148-364.213c-15.699,0-28.4-12.704-28.4-28.399V163.258
			C506.65,163.258,125.715,472.781,125.715,472.781L125.715,472.781z"
    />
  </svg>
);

export const GoogleSVG = () => (
  <svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor">
    <g>
      <path
        fill="#59C36A"
        d="M827.301,875.968c-84.521,71.388-194.169,116.693-313.528,116.693c-177.609,0-333.52-97.848-418.041-240.62
				l31.646-145.858l140.255-26.039c32.553,105.078,130.779,182.178,246.141,182.178c55.964,0,107.937-17.703,150.767-49.112
				l134.777,20.558L827.301,875.968z"
      />
      <path
        fill="#00A66C"
        d="M827.301,875.968l-27.984-142.201l-134.777-20.558c-42.83,31.409-94.803,49.112-150.767,49.112v230.34
				C633.132,992.661,742.779,947.355,827.301,875.968z"
      />
      <g id="Connected_Home_1_">
        <g>
          <g>
            <g>
              <path
                fill="#FFDA2D"
                d="M256.781,505.331c0,26.267,3.998,51.396,10.851,74.813l-171.9,171.897
								c-42.83-71.957-69.29-156.48-69.29-246.71c0-90.233,26.46-174.754,69.29-246.711l137.965,23.743l33.936,148.154
								C260.779,453.932,256.781,479.06,256.781,505.331L256.781,505.331z"
              />
            </g>
          </g>
        </g>
      </g>
      <path
        fill="#4086F4"
        d="M1001.103,505.331c0,148.48-68.719,281.547-173.802,370.637L664.539,713.209
				c33.121-23.988,61.107-55.971,79.384-93.66h-230.15c-15.993,0-28.556-12.567-28.556-28.554V419.666
				c0-15.99,12.563-28.554,28.556-28.554h450.78c13.707,0,25.698,9.708,27.983,23.412
				C998.247,444.225,1001.103,475.063,1001.103,505.331L1001.103,505.331z"
      />
      <path
        fill="#4175DF"
        d="M743.924,619.549c-18.275,37.689-46.264,69.672-79.382,93.66l162.759,162.759
				c105.083-89.09,173.802-222.153,173.802-370.637c0-30.269-2.855-61.106-8.567-90.807c-2.284-13.704-14.278-23.412-27.984-23.412
				H513.772v228.437H743.924z"
      />
      <path
        fill="#FF641A"
        d="M835.297,154.107c0.571,7.996-2.855,15.422-7.996,21.131L705.086,296.881
				c-9.704,10.278-25.694,11.421-37.118,2.855c-45.119-33.693-98.231-51.396-154.195-51.396
				c-115.361,0-213.588,77.095-246.141,182.178L95.731,258.62C180.253,115.848,336.163,18,513.772,18
				c113.647,0,224.439,41.88,311.244,114.978C831.298,138.119,834.723,146.112,835.297,154.107L835.297,154.107z"
      />
      <path
        fill="#F03800"
        d="M667.966,299.736c11.422,8.567,27.411,7.423,37.119-2.855l122.214-121.643
				c5.143-5.709,8.569-13.133,7.996-21.131c-0.575-7.997-3.999-15.988-10.279-21.13C738.212,59.88,627.42,18,513.772,18v230.34
				C569.736,248.34,622.849,266.043,667.966,299.736z"
      />
    </g>
  </svg>
);

export const FacebookSVG = () => (
  <svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor">
    <g>
      <path
        fill="#4A7AFF"
        d="M1015.363,506.525c0,279.749-226.775,506.524-506.525,506.524c-279.749,0-506.524-226.775-506.524-506.524
	C2.313,226.775,229.089,0,508.838,0C788.588,0,1015.363,226.775,1015.363,506.525z"
      />
      <path
        fill="#FFFFFF"
        d="M663.688,149.015v114.697c0,0-131.686-19.113-131.686,65.843v84.957h118.941L636.08,544.072H532.002v337.709
	H400.316V544.072l-112.572-2.126V414.512H398.19V316.81c0,0-7.288-145.343,135.938-172.038
	C593.602,133.68,663.688,149.015,663.688,149.015z"
      />
      <path
        fill="#DCE1EB"
        d="M663.688,263.712V149.015c0,0-70.086-15.335-129.56-4.243c-9.291,1.73-17.932,3.973-25.993,6.623v730.387
	h23.867V544.072h104.07l14.871-129.561H532.002c0,0,0,0,0-84.957C532.002,244.599,663.688,263.712,663.688,263.712z"
      />
    </g>
  </svg>
);

export const TwitterSVG = () => (
  <svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor">
    <path
      fill="#03A9F4"
      d="M1006.701,163.276c-6.71-7.344-17.513-9.249-26.334-4.649c-9.059,4.107-18.431,7.508-28.042,10.136
      c14.983-19.171,26.285-40.938,33.356-64.208c3.113-11.713-3.859-23.729-15.573-26.834c-6.251-1.668-12.92-0.484-18.218,3.219
      c-33.365,18.063-68.824,31.936-105.59,41.3c-75.666-71.428-190.939-80.332-276.685-21.372
      c-66.047,44.667-102.419,121.845-94.796,201.207c-143.168-12.197-274.902-83.141-363.884-195.983
      c-4.574-5.527-11.491-8.575-18.653-8.206c-7.262,0.436-13.833,4.443-17.545,10.703c-30.202,49.365-38.951,108.916-24.231,164.878
      c7.548,28.757,20.485,55.813,38.136,79.74c-7.942-3.894-15.434-8.682-22.292-14.268c-9.413-7.632-23.229-6.193-30.86,3.22
      c-3.17,3.909-4.904,8.788-4.912,13.815c1.314,81.186,45.891,155.489,116.917,194.842c-9.586-1.175-19.04-3.204-28.264-6.054
      c-11.607-3.491-23.846,3.088-27.338,14.687c-1.519,5.06-1.166,10.505,1.004,15.326c30.826,69.055,92.447,119.488,166.24,136.039
      c-70.303,39.665-151.25,56.33-231.5,47.657c-10.399-1.323-20.255,5.002-23.385,15.015c-3.228,9.931,0.993,20.765,10.095,25.891
      c98.254,58.384,210.029,90.139,324.3,92.16c109.632-0.403,216.707-33.152,307.808-94.132
      C820.37,681.983,928.769,474.763,913.672,289.359c37.184-27.533,69.439-61.153,95.403-99.446
      C1014.406,181.519,1013.437,170.586,1006.701,163.276z"
    />
  </svg>
);

export const ImageSvg = () => (
  <svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor">
    <g>
      <g>
        <path
          fill="#E5E1E5"
          d="M163.033,1011.756L2.746,191.353c-4.863-24.879,11.365-48.991,36.245-53.852l124.042-24.234l194.642-42.82
          l279.663,941.308H163.033V1011.756z"
        />
      </g>
      <path
        fill="#99E6FC"
        d="M163.033,680.979L68.355,196.393l94.678-18.501l143.802-23.615l62.994,584.599L163.033,680.979z"
      />
      <g id="XMLID_159_">
        <g>
          <path
            fill="#F9F7F8"
            d="M1014.357,64.9v957.461c0,25.351-20.549,45.899-45.899,45.899H208.93
            c-25.351,0-45.901-20.549-45.901-45.899V64.9c0-25.35,20.551-45.9,45.901-45.9h759.528C993.809,19,1014.357,39.551,1014.357,64.9
            z"
          />
        </g>
        <path
          fill="#EFEDEF"
          d="M574.473,971.206c-90.848,0-164.495-73.646-164.495-164.493V19H208.93
          c-25.351,0-45.901,20.551-45.901,45.9v957.461c0,25.351,20.551,45.899,45.901,45.899h759.528
          c25.351,0,45.899-20.549,45.899-45.899v-51.155H574.473z"
        />
        <path
          fill="#FEC165"
          d="M950.933,737.554V234.861c0-7.122-5.774-12.896-12.897-12.896H239.354c-7.12,0-12.896,5.774-12.896,12.896
          v502.692H950.933z"
        />
        <path
          fill="#FDB441"
          d="M409.978,221.965H239.354c-7.12,0-12.896,5.774-12.896,12.896v502.692h183.52V221.965z"
        />
        <circle fill="#FEE903" cx="588.693" cy="600.309" r="246.948" />
        <path
          fill="#F4D902"
          d="M409.978,770.729V429.889c-42.274,44.316-68.229,104.339-68.229,170.419
          C341.748,666.391,367.703,726.41,409.978,770.729z"
        />
        <g>
          <path
            fill="#99E6FC"
            d="M902.813,668.316c-57.591-25.393-122.604-28.267-182.203-8.034l-51.163,17.336
            c-52.369,17.759-109.135,17.759-161.505,0l-51.163-17.336c-59.602-20.232-124.611-17.358-182.182,8.034l-48.142,21.226v105.269
            l80.12,33.354h599.658l44.699-33.354V689.542L902.813,668.316z"
          />
          <path
            fill="#62DBFB"
            d="M409.978,828.165V649.264c-45.72-6.239-92.605,0.184-135.379,19.053l-48.141,21.226v105.269
            l80.119,33.354H409.978z"
          />
          <path
            fill="#62DBFB"
            d="M950.933,794.811v61.709c0,5.452-4.424,9.878-9.879,9.878H236.332c-5.453,0-9.877-4.426-9.877-9.878
            v-61.709l48.142-21.229c57.57-25.39,122.58-28.268,182.182-8.055l51.163,17.358c52.37,17.759,109.136,17.759,161.505,0
            l51.163-17.358c59.6-20.213,124.612-17.335,182.203,8.055L950.933,794.811z"
          />
          <path
            fill="#01D0FB"
            d="M236.332,866.397h184.86c-7.214-18.51-11.215-38.625-11.215-59.685v-52.188
            c-45.72-6.231-92.605,0.192-135.379,19.061l-48.141,21.226v61.71c-0.003,5.451,4.421,9.875,9.874,9.875V866.397z"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const NhanSuSvg = ({ opacity, width = 46, height = 46 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 46 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity={opacity} filter="url(#filter0_d_1184_15068)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.3042 8.82482C14.3042 11.226 12.3576 13.1726 9.95643 13.1726C7.55522 13.1726 5.60866 11.226 5.60866 8.82482C5.60866 6.42361 7.55522 4.47705 9.95643 4.47705C12.3576 4.47705 14.3042 6.42361 14.3042 8.82482ZM11.6955 28.8252C11.6955 30.0243 12.5077 31.0651 13.6712 31.3564L13.9912 31.4356L13.4312 37.599C13.3903 38.0468 13.0146 38.3902 12.5651 38.3902H7.34777C6.89821 38.3902 6.52256 38.0468 6.48169 37.5998L5.66431 28.6008L3.59477 27.9113C3.23913 27.7921 3 27.4608 3 27.086V19.2601C3 16.8627 4.95041 14.9123 7.34777 14.9123H12.5651C12.8651 14.9123 13.1581 14.9427 13.4416 15.001C12.3634 16.1001 11.6955 17.6027 11.6955 19.2601V28.8252Z"
        fill="#A9D7AB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.3908 8.8258C40.3908 11.227 38.4442 13.1736 36.043 13.1736C33.6418 13.1736 31.6953 11.227 31.6953 8.8258C31.6953 6.42459 33.6418 4.47803 36.043 4.47803C38.4442 4.47803 40.3908 6.42459 40.3908 8.8258ZM34.3039 28.8262C34.3039 30.0254 33.4917 31.0662 32.3282 31.3575L32.0083 31.4366L32.5682 37.6C32.6091 38.0479 32.9848 38.3913 33.4343 38.3913H38.6516C39.1012 38.3913 39.4768 38.0479 39.5177 37.6009L40.3351 28.6019L42.4046 27.9123C42.7603 27.7932 42.9994 27.4619 42.9994 27.0871V19.2612C42.9994 16.8638 41.049 14.9134 38.6516 14.9134H33.4343C33.1343 14.9134 32.8413 14.9438 32.5578 15.0021C33.6361 16.1012 34.3039 17.6038 34.3039 19.2612V28.8262Z"
        fill="#A9D7AB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.0866 7.08688C29.0866 10.4486 26.3615 13.1738 22.9998 13.1738C19.6381 13.1738 16.9129 10.4486 16.9129 7.08688C16.9129 3.72519 19.6381 1 22.9998 1C26.3615 1 29.0866 3.72519 29.0866 7.08688ZM17.7825 14.9134H28.2171C30.6145 14.9134 32.5649 16.8638 32.5649 19.2612V28.8262C32.5649 29.2254 32.2936 29.5732 31.9066 29.6697L29.0319 30.388L28.2145 40.2026C28.1762 40.6539 27.7997 41 27.3476 41H18.652C18.1998 41 17.8233 40.6539 17.7851 40.2026L16.9677 30.388L14.0929 29.6697C13.706 29.5732 13.4347 29.2254 13.4347 28.8262V19.2612C13.4347 16.8638 15.3851 14.9134 17.7825 14.9134Z"
        fill="url(#paint0_linear_1184_15068)"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_1184_15068"
        x="0"
        y="0"
        width="45.9994"
        height="46"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="1.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.513174 0 0 0 0 0.582568 0 0 0 0 0.63282 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1184_15068"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1184_15068"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_1184_15068"
        x1="22.9998"
        y1="1"
        x2="22.9998"
        y2="41"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#33BA4C" />
        <stop offset="1" stopColor="#219737" />
      </linearGradient>
    </defs>
  </svg>
);

export const CongVanSvg = ({ opacity, width = 49, height = 48 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 49 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity={opacity} filter="url(#filter0_d_1184_15172)">
      <path
        d="M40.5 32H8.83332C7.91285 32 7.16666 32.7462 7.16666 33.6667V40.3333C7.16666 41.2538 7.91285 42 8.83332 42H40.5C41.4205 42 42.1667 41.2538 42.1667 40.3333V33.6667C42.1667 32.7462 41.4205 32 40.5 32Z"
        fill="#188D2E"
      />
      <path
        d="M31.3333 13.6667C30.8727 13.6667 30.5 13.2935 30.5 12.8333V8.66667H18.8333V12.8333C18.8333 13.2935 18.4606 13.6667 18 13.6667C17.5394 13.6667 17.1667 13.2935 17.1667 12.8333V7.83333C17.1667 7.37312 17.5394 7 18 7H31.3333C31.7939 7 32.1667 7.37312 32.1667 7.83333V12.8333C32.1667 13.2935 31.7939 13.6667 31.3333 13.6667Z"
        fill="#EF5816"
      />
      <path
        d="M42.1667 12H7.16667C6.24619 12 5.5 12.7462 5.5 13.6667V32C5.5 32.9205 6.24619 33.6667 7.16667 33.6667H42.1667C43.0871 33.6667 43.8333 32.9205 43.8333 32V13.6667C43.8333 12.7462 43.0871 12 42.1667 12Z"
        fill="url(#paint0_linear_1184_15172)"
      />
      <path
        d="M28 37.0002H21.3333C20.8731 37.0002 20.5 36.6271 20.5 36.1668V31.1668C20.5 30.7066 20.8731 30.3335 21.3333 30.3335H28C28.4602 30.3335 28.8333 30.7066 28.8333 31.1668V36.1668C28.8333 36.6271 28.4602 37.0002 28 37.0002Z"
        fill="#BDF4C5"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_1184_15172"
        x="2.5"
        y="6"
        width="44.3333"
        height="41"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="1.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.513174 0 0 0 0 0.582568 0 0 0 0 0.63282 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1184_15172"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1184_15172"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_1184_15172"
        x1="24.6667"
        y1="12"
        x2="24.6667"
        y2="33.6667"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#33BA4C" />
        <stop offset="1" stopColor="#219737" />
      </linearGradient>
    </defs>
  </svg>
);

export const CRMSvg = ({ opacity, width = 49, height = 48 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity={opacity} filter="url(#filter0_d_1184_15078)">
        <path
          d="M41.8131 31.3245L35.6905 28.8053C35.5488 28.7467 35.4247 28.6509 35.3305 28.5273C35.2363 28.4038 35.1754 28.2569 35.1539 28.1015L34.7957 25.5269C36.0028 24.8255 37.0077 23.8077 37.708 22.5771C38.4084 21.3464 38.7791 19.947 38.7826 18.5211V13.2198C38.7813 12.0466 38.3625 10.9145 37.6053 10.037C36.848 9.15959 35.8047 8.59751 34.6722 8.45684L33.9131 6.89543C33.7374 6.54242 33.4437 6.26656 33.0859 6.11866C32.7281 5.97077 32.3305 5.96079 31.9661 6.09058L27.2818 7.81207C25.925 8.36068 24.7902 9.36808 24.0644 10.6684C24.8528 11.2794 25.4929 12.07 25.9344 12.9782C26.3758 13.8863 26.6066 14.8873 26.6087 15.9026V21.2039C26.6066 22.3987 26.3915 23.5829 25.9739 24.6979C26.3302 25.0091 26.7129 25.2868 27.1174 25.5278L26.7592 28.1033C26.7375 28.2586 26.6766 28.4052 26.5824 28.5286C26.4882 28.652 26.3641 28.7477 26.2226 28.8062L23.0809 30.0984L28.547 32.3467C29.5172 32.7418 30.3491 33.4286 30.934 34.3173C31.519 35.2061 31.8299 36.2555 31.8261 37.3287V41.7724C31.8232 42.0777 31.7691 42.3803 31.6661 42.6667H43.1304C43.3611 42.6667 43.5822 42.5724 43.7453 42.4047C43.9084 42.237 44 42.0096 44 41.7724V34.6459C44.0022 33.9303 43.7948 33.2307 43.4047 32.6383C43.0146 32.0458 42.4599 31.588 41.8131 31.3245Z"
          fill="#A9D7AB"
        />
        <path
          d="M29.2174 42.6663H4.86958C4.63896 42.6663 4.41778 42.572 4.25471 42.4043C4.09163 42.2366 4.00002 42.0092 4.00002 41.772V37.3283C3.99779 36.6128 4.20526 35.9132 4.59536 35.3207C4.98547 34.7282 5.54012 34.2704 6.18697 34.0069L12.3096 31.4877C12.4511 31.4293 12.5752 31.3335 12.6693 31.2102C12.7635 31.0868 12.8245 30.9401 12.8461 30.7848L13.2044 28.2093C11.9972 27.5079 10.9923 26.4901 10.292 25.2595C9.59168 24.0289 9.2209 22.6294 9.2174 21.2035V16.5533C9.2657 15.2384 9.68351 13.9661 10.4203 12.8903C11.157 11.8146 12.1811 10.9815 13.3687 10.4918L18.0539 8.77301C18.4182 8.64386 18.8155 8.65415 19.173 8.80199C19.5305 8.94984 19.8241 9.22531 20 9.57786L20.7583 11.1357C21.8915 11.2762 22.9355 11.8387 23.693 12.717C24.4505 13.5952 24.8691 14.7283 24.8696 15.9022V21.2035C24.8662 22.6295 24.4955 24.0292 23.7952 25.26C23.0948 26.4908 22.0899 27.5087 20.8826 28.2102L21.2409 30.7848C21.2624 30.9403 21.3233 31.0871 21.4174 31.2107C21.5116 31.3342 21.6358 31.4301 21.7774 31.4886L27.9 34.0069C28.5469 34.2704 29.1015 34.7282 29.4916 35.3207C29.8817 35.9132 30.0892 36.6128 30.0869 37.3283V41.772C30.0869 42.0092 29.9953 42.2366 29.8323 42.4043C29.6692 42.572 29.448 42.6663 29.2174 42.6663Z"
          fill="url(#paint0_linear_1184_15078)"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1184_15078"
          x="1"
          y="5"
          width="46"
          height="42.6665"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.513174 0 0 0 0 0.582568 0 0 0 0 0.63282 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1184_15078"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1184_15078"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_1184_15078"
          x1="17.0435"
          y1="8.68311"
          x2="17.0435"
          y2="42.6663"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#219737" />
          <stop offset="1" stop-color="#33BA4C" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const BaoCaoSvg = ({ opacity, width = 49, height = 48 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity={opacity} clip-path="url(#clip0_1184_15087)">
        <g filter="url(#filter0_d_1184_15087)">
          <path
            d="M27.978 26.6084H21.0215C20.5415 26.6084 20.152 26.998 20.152 27.478V43.1299C20.152 43.6099 20.5415 43.9995 21.0215 43.9995H27.978C28.458 43.9995 28.8475 43.6099 28.8475 43.1299V27.478C28.8475 26.998 28.458 26.6084 27.978 26.6084Z"
            fill="#4FC665"
          />
          <path
            d="M12.326 35.3032H5.36955C4.88956 35.3032 4.5 35.6928 4.5 36.1728V43.1292C4.5 43.6092 4.88956 43.9988 5.36955 43.9988H12.326C12.806 43.9988 13.1955 43.6092 13.1955 43.1292V36.1728C13.1955 35.6928 12.806 35.3032 12.326 35.3032Z"
            fill="#7ED78E"
          />
          <path
            d="M43.6299 17.9126H36.6735C36.1935 17.9126 35.804 18.3022 35.804 18.7822V43.1297C35.804 43.6097 36.1935 43.9992 36.6735 43.9992H43.6299C44.1099 43.9992 44.4995 43.6097 44.4995 43.1297V18.7822C44.4995 18.3022 44.1099 17.9126 43.6299 17.9126Z"
            fill="url(#paint0_linear_1184_15087)"
          />
          <path
            d="M25.1145 17.6581L35.804 6.96866V12.6955C35.804 13.1755 36.1935 13.5651 36.6735 13.5651C37.1535 13.5651 37.5431 13.1755 37.5431 12.6955V4.86955C37.5431 4.38956 37.1535 4 36.6735 4H28.8475C28.3676 4 27.978 4.38956 27.978 4.86955C27.978 5.34955 28.3676 5.73911 28.8475 5.73911H34.5744L24.4998 15.8138L18.1581 9.47211C17.8181 9.13211 17.2686 9.13211 16.9286 9.47211L8.23302 18.1677L9.46257 19.3972L17.5433 11.3164L23.885 17.6581C24.225 17.9981 24.7746 17.9981 25.1145 17.6581Z"
            fill="#EF5816"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_1184_15087"
          x="1.5"
          y="3"
          width="45.9995"
          height="45.9995"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.513174 0 0 0 0 0.582568 0 0 0 0 0.63282 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1184_15087"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1184_15087"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_1184_15087"
          x1="40.1517"
          y1="17.9126"
          x2="40.1517"
          y2="43.9992"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#219737" />
          <stop offset="1" stop-color="#33BA4C" />
        </linearGradient>
        <clipPath id="clip0_1184_15087">
          <rect
            width="48"
            height="48"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ChungSvg = ({ opacity, width = 49, height = 48 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity={opacity} clip-path="url(#clip0_1184_15101)">
        <g filter="url(#filter0_d_1184_15101)">
          <path
            d="M42.9025 20.6668L38.1667 20.2743C37.8538 19.1214 37.3942 18.0135 36.7992 16.9777L39.875 13.3427C40.0101 13.1831 40.0802 12.9787 40.0716 12.7698C40.0629 12.561 39.9761 12.363 39.8284 12.2152L36.285 8.67933C36.1372 8.53157 35.9392 8.44476 35.7304 8.43611C35.5215 8.42747 35.3171 8.49763 35.1575 8.63267L31.5233 11.7077C30.4872 11.1111 29.379 10.6493 28.2258 10.3335L27.8333 5.59767C27.816 5.38885 27.7205 5.19425 27.5661 5.05264C27.4117 4.91102 27.2096 4.83278 27 4.8335H22C21.7905 4.83278 21.5884 4.91102 21.4339 5.05264C21.2795 5.19425 21.1841 5.38885 21.1667 5.59767L20.7742 10.3335C19.6213 10.6464 18.5133 11.1059 17.4775 11.701L13.8425 8.6285C13.683 8.49346 13.4785 8.4233 13.2697 8.43195C13.0608 8.44059 12.8629 8.5274 12.715 8.67517L9.17918 12.2152C9.03142 12.363 8.94461 12.561 8.93596 12.7698C8.92732 12.9787 8.99747 13.1831 9.13252 13.3427L12.2075 16.9768C11.611 18.013 11.1492 19.1212 10.8333 20.2743L6.09752 20.6668C5.8887 20.6842 5.6941 20.7796 5.55248 20.9341C5.41087 21.0885 5.33263 21.2906 5.33335 21.5002V26.5002C5.33263 26.7097 5.41087 26.9118 5.55248 27.0663C5.6941 27.2207 5.8887 27.3161 6.09752 27.3335L10.8367 27.7293C11.1495 28.8822 11.6091 29.9902 12.2042 31.026L9.12835 34.6577C8.99331 34.8172 8.92315 35.0217 8.9318 35.2305C8.94044 35.4394 9.02725 35.6373 9.17502 35.7852L12.7108 39.321C12.8586 39.4685 13.0564 39.5552 13.2651 39.5638C13.4737 39.5725 13.678 39.5025 13.8375 39.3677L17.4725 36.2927C18.5099 36.8898 19.6195 37.3516 20.7742 37.6668L21.1667 42.4027C21.1841 42.6115 21.2795 42.8061 21.4339 42.9477C21.5884 43.0893 21.7905 43.1676 22 43.1668H27C27.2096 43.1676 27.4117 43.0893 27.5661 42.9477C27.7205 42.8061 27.816 42.6115 27.8333 42.4027L28.23 37.6602C29.3824 37.3463 30.49 36.8864 31.5258 36.2918L35.1609 39.3677C35.3204 39.5027 35.5249 39.5729 35.7337 39.5642C35.9425 39.5556 36.1405 39.4688 36.2884 39.321L39.8242 35.7852C39.972 35.6373 40.0588 35.4394 40.0674 35.2305C40.076 35.0217 40.0059 34.8172 39.8708 34.6577L36.7959 31.0235C37.3913 29.9871 37.8519 28.879 38.1667 27.726L42.9025 27.3335C43.1113 27.3161 43.3059 27.2207 43.4475 27.0663C43.5892 26.9118 43.6674 26.7097 43.6667 26.5002V21.5002C43.6674 21.2906 43.5892 21.0885 43.4475 20.9341C43.3059 20.7796 43.1113 20.6842 42.9025 20.6668ZM24.5 29.8335C23.3463 29.8335 22.2185 29.4914 21.2592 28.8504C20.2999 28.2094 19.5522 27.2984 19.1107 26.2325C18.6692 25.1666 18.5537 23.9937 18.7788 22.8621C19.0038 21.7306 19.5594 20.6912 20.3752 19.8754C21.191 19.0596 22.2304 18.504 23.362 18.2789C24.4935 18.0538 25.6664 18.1694 26.7323 18.6109C27.7982 19.0524 28.7093 19.8001 29.3503 20.7593C29.9912 21.7186 30.3333 22.8464 30.3333 24.0002C30.3333 25.5473 29.7188 27.031 28.6248 28.125C27.5308 29.2189 26.0471 29.8335 24.5 29.8335Z"
            fill="url(#paint0_linear_1184_15101)"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_1184_15101"
          x="1.5"
          y="3"
          width="46"
          height="46"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.513174 0 0 0 0 0.582568 0 0 0 0 0.63282 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1184_15101"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1184_15101"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_1184_15101"
          x1="24.5"
          y1="4.8335"
          x2="24.5"
          y2="43.1668"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#219737" />
          <stop offset="1" stop-color="#33BA4C" />
        </linearGradient>
        <clipPath id="clip0_1184_15101">
          <rect
            width="48"
            height="48"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const TaiChinhSvg = ({ opacity, width = 49, height = 48 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity={opacity} clipPath="url(#clip0_1184_15096)">
        <g filter="url(#filter0_d_1184_15096)">
          <path
            d="M43.1308 25.7397H35.3046C33.3863 25.7397 31.8263 27.2998 31.8263 29.218C31.8263 31.1363 33.3863 32.6963 35.3046 32.6963H43.1308C43.6108 32.6963 44.0003 32.3068 44.0003 31.8267V26.6093C44.0003 26.1293 43.6108 25.7397 43.1308 25.7397Z"
            fill="url(#paint0_linear_1184_15096)"
          />
          <path
            d="M43.1308 25.7397H35.3046C33.3863 25.7397 31.8263 27.2998 31.8263 29.218C31.8263 31.1363 33.3863 32.6963 35.3046 32.6963H43.1308C43.6108 32.6963 44.0003 32.3068 44.0003 31.8267V26.6093C44.0003 26.1293 43.6108 25.7397 43.1308 25.7397Z"
            fill="#90CB9B"
          />
          <path
            d="M36.1742 4H11.8261C11.3453 4 10.9566 4.3887 10.9566 4.86957V10.9566C10.9566 11.4374 11.3453 11.8261 11.8261 11.8261H36.1742C36.655 11.8261 37.0437 11.4374 37.0437 10.9566V4.86957C37.0437 4.3887 36.655 4 36.1742 4Z"
            fill="#EF5816"
          />
          <path
            d="M40.522 14.4346H8.34786C6.90959 14.4346 5.73914 13.2642 5.73914 11.8259C5.73914 10.3876 6.90959 9.21717 8.34786 9.21717H9.21743V7.47803H8.34786C5.95045 7.47803 4 9.42848 4 11.8259V37.913C4 41.2696 6.73046 44 10.087 44H40.522C41.002 44 41.3916 43.6105 41.3916 43.1305V34.4348H35.3046C32.4272 34.4348 30.0872 32.0947 30.0872 29.2173C30.0872 26.3399 32.4272 23.9999 35.3046 23.9999H41.3916V15.3042C41.3916 14.8242 41.002 14.4346 40.522 14.4346Z"
            fill="url(#paint1_linear_1184_15096)"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_1184_15096"
          x="1"
          y="3"
          width="46.0003"
          height="46"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.513174 0 0 0 0 0.582568 0 0 0 0 0.63282 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1184_15096"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1184_15096"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_1184_15096"
          x1="44.0003"
          y1="29.218"
          x2="31.8263"
          y2="29.218"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F9812B" />
          <stop offset="1" stopColor="#E96232" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1184_15096"
          x1="22.6958"
          y1="7.47803"
          x2="22.6958"
          y2="44"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#219737" />
          <stop offset="1" stopColor="#33BA4C" />
        </linearGradient>
        <clipPath id="clip0_1184_15096">
          <rect
            width="48.0004"
            height="48"
            fill="white"
            transform="translate(0.499817)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const TaiSanSvg = ({ opacity, width = 49, height = 48 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity={opacity}>
        <g
          clip-path="url(#clip0_1184_15111)"
          filter="url(#filter0_d_1184_15111)"
        >
          <path
            d="M42.9417 28.9442C42.5326 28.5271 42.0003 28.2527 41.4233 28.1615C40.8463 28.0703 40.2553 28.167 39.7375 28.4375L32.63 31.9875C32.3609 32.8042 31.856 33.5229 31.179 34.0531C30.502 34.5832 29.6832 34.9011 28.8258 34.9667L19.5758 35.6275H19.515C19.294 35.6352 19.079 35.5549 18.9172 35.4041C18.7555 35.2532 18.6602 35.0444 18.6525 34.8233C18.6448 34.6023 18.7251 34.3873 18.876 34.2255C19.0268 34.0638 19.2357 33.9686 19.4567 33.9608L19.5158 33.9567L28.6892 33.4792C29.3657 33.4299 29.9986 33.1264 30.4606 32.6296C30.9225 32.1328 31.1793 31.4796 31.1793 30.8013C31.1793 30.1229 30.9225 29.4697 30.4606 28.9729C29.9986 28.4761 29.3657 28.1726 28.6892 28.1233L20.1058 26.5633C19.7141 26.4922 19.3295 26.3862 18.9567 26.2467L14.3433 24.5167C13.362 24.1485 12.3076 24.0169 11.2658 24.1325L6.09167 24.7075C5.88777 24.7301 5.69935 24.8271 5.5625 24.9799C5.42565 25.1327 5.34999 25.3307 5.35001 25.5358V35.6192C5.35001 35.8402 5.4378 36.0521 5.59408 36.2084C5.75036 36.3647 5.96233 36.4525 6.18334 36.4525H6.88167C8.06206 36.4526 9.22128 36.766 10.2408 37.3608L16.465 41C17.8928 41.8328 19.5792 42.1054 21.1967 41.765L33.0792 39.265C34.0321 39.0646 34.9295 38.6578 35.7083 38.0733L42.605 32.8958C42.9042 32.6709 43.1526 32.3854 43.334 32.0579C43.5153 31.7304 43.6254 31.3683 43.6572 30.9953C43.689 30.6223 43.6417 30.2468 43.5184 29.8934C43.3951 29.5399 43.1986 29.2165 42.9417 28.9442Z"
            fill="url(#paint0_linear_1184_15111)"
          />
          <path
            d="M40.3334 14.0002C40.1385 14.0004 39.9498 13.9323 39.8 13.8077L30.3334 5.91691L20.8675 13.8077C20.7834 13.8779 20.6862 13.9308 20.5816 13.9634C20.477 13.996 20.367 14.0077 20.2579 13.9978C20.1488 13.9879 20.0427 13.9566 19.9457 13.9056C19.8487 13.8547 19.7627 13.7852 19.6925 13.7011C19.6224 13.6169 19.5695 13.5198 19.5369 13.4152C19.5043 13.3106 19.4926 13.2006 19.5025 13.0915C19.5124 12.9824 19.5437 12.8763 19.5946 12.7793C19.6455 12.6823 19.715 12.5962 19.7992 12.5261L29.7992 4.19274C29.949 4.06758 30.1381 3.99902 30.3334 3.99902C30.5286 3.99902 30.7177 4.06758 30.8675 4.19274L40.8675 12.5261C40.9994 12.6357 41.0942 12.7833 41.1391 12.9488C41.184 13.1143 41.1767 13.2896 41.1183 13.4508C41.0599 13.612 40.9532 13.7513 40.8127 13.8496C40.6722 13.9479 40.5048 14.0005 40.3334 14.0002Z"
            fill="#EF5816"
          />
          <path
            d="M30.3333 8.08789L22 15.0329V24.0004C22 24.2214 22.0878 24.4334 22.2441 24.5896C22.4004 24.7459 22.6123 24.8337 22.8333 24.8337H27.8333V19.0004H32.8333V24.8337H37.8333C38.0543 24.8337 38.2663 24.7459 38.4226 24.5896C38.5789 24.4334 38.6667 24.2214 38.6667 24.0004V15.0329L30.3333 8.08789Z"
            fill="url(#paint1_linear_1184_15111)"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_1184_15111"
          x="1.5"
          y="3"
          width="46"
          height="46"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.513174 0 0 0 0 0.582568 0 0 0 0 0.63282 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1184_15111"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1184_15111"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_1184_15111"
          x1="24.5084"
          y1="24.0918"
          x2="24.5084"
          y2="41.9079"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#219737" />
          <stop offset="1" stop-color="#33BA4C" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1184_15111"
          x1="30.3333"
          y1="8.08789"
          x2="30.3333"
          y2="24.8337"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#219737" />
          <stop offset="1" stop-color="#33BA4C" />
        </linearGradient>
        <clipPath id="clip0_1184_15111">
          <rect
            width="40"
            height="40"
            fill="white"
            transform="translate(4.5 4)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
